import { TabsList as RadixTabsList } from '@radix-ui/react-tabs'
import React from 'react'

interface TabsListProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'className'> {
  children: React.ReactNode
}

export function TabsList ({ children, ...props }: TabsListProps) {
  return (
    <RadixTabsList
      {...props}
      className='bg-gray-50 [grid-area:1/1] flex flex-col items-stretch py-1.5 rounded-l-lg'
    >
      {children}
    </RadixTabsList>
  )
}

TabsList.displayName = 'FiltersDropdown.TabsList'
